import { dialogs } from './registered-dialogs';
export const registerDialog = (modalType, Component) => {
    dialogs.set(modalType, Component);
};
export const unregisterDialog = (modalType) => {
    dialogs.delete(modalType);
};
